import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import CustomDialog from './CustomDialog';

import { sendError } from '../../../appsignal';

const ErrorDialog = props => {
  const { open, error, onRequestClose } = props;

  if (error) {
    return (
      <CustomDialog open={open} onRequestClose={onRequestClose}>
        <div className="notification-container">
          <DialogContent>
            <div className="notification-body">
              <ErrorDialogBody error={error} />
            </div>
          </DialogContent>
          <DialogActions>
            <div className="notification-action">
              <button className="accept" onClick={onRequestClose}>
                <FormattedMessageWrappedInSpan id="errorDialog.okButton" defaultMessage="OK" />
              </button>
            </div>
          </DialogActions>
        </div>
      </CustomDialog>
    );
  }

  return null;
};

ErrorDialog.propTypes = {
  open: PropTypes.bool,
  error: PropTypes.object,
  onRequestClose: PropTypes.func,
};

const ErrorDialogBody = ({ error }) => {
  const lowerCaseMsg = error.message.toLowerCase();
  if (lowerCaseMsg.includes('failed to fetch')) {
    return (
      <FormattedMessageWrappedInSpan
        id="errorDialogBody.failedToFetch"
        defaultMessage="The server didn't respond. You may retry your request when the server comes back up."
      />
    );
  } else if (lowerCaseMsg.includes('unauthenticated')) {
    return (
      <FormattedMessageWrappedInSpan
        id="errorDialogBody.magicLinkExpired"
        defaultMessage="The Magic Link you are using to try to login is expired. Please request a new one."
      />
    );
  } else if (lowerCaseMsg.includes('badarg')) {
    return (
      <FormattedMessageWrappedInSpan
        id="errorDialogBody.magicLinkInvalidToken"
        defaultMessage="The token is malformed. Please try to copy and paste the text version of the link. You can find it in the e-mail you received. If the error still occurs, please contact our support."
      />
    );
  } else if (lowerCaseMsg.includes('send_failed')) {
    return (
      <FormattedMessageWrappedInSpan
        id="errorDialogBody.failedToSendEmail"
        defaultMessage="An error occurred while sending the email. Please try again later."
      />
    );
  } else if (lowerCaseMsg.includes('has already been taken')) {
    return (
      <FormattedMessageWrappedInSpan
        id="errorDialogBody.duplicateItemInCart"
        defaultMessage="This item is already in your cart"
      />
    );
  } else if (lowerCaseMsg.includes('incompatible line item price currency')) {
    return (
      <FormattedMessageWrappedInSpan
        id="errorDialogBody.differentCurrenciesInCart"
        defaultMessage="Your cart can not have different currencies"
      />
    );
  } else if (lowerCaseMsg.includes('no_face_found')) {
    return (
      <FormattedMessageWrappedInSpan
        id="errorDialogBody.noFaceFound"
        defaultMessage="There is no big enough face in this image. Please upload a photo where your face can clearly be seen and is at least 25% in width or height of the image."
      />
    );
  }

  // By default send the unknown error to Appsignal and show the user a default
  // message
  sendError(error);
  return (
    <FormattedMessageWrappedInSpan
      id="errorDialogBody.unknowError"
      defaultMessage="An unknown error has occured"
    />
  );
};

ErrorDialogBody.propTypes = {
  error: PropTypes.object,
};

export default ErrorDialog;
